import { Box, Button, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GridContainer = styled(Grid)(() => ({
  padding: '32px 32px 64px 120px',
  backgroundColor: '#FAFCFF',
}));

export const SectionBox = styled(Box)(() => ({
  margin: '20px 160px 60px',
}));

export const EditButton = styled(Button)(({ theme }) => ({
  width: 282,
  height: 40,
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: 10,
  color: theme.palette.secondary.main,
  fontWeight: 600,
  fontSize: 15,
  backgroundColor: 'transparent',
  display: 'flex',
  gap: 8,
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const GalleryContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '32px',
  marginTop: '32px',
}));

export const FlexCenterBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
}));
